import * as Schema from "../../types/schema";
import { RichText } from "../richText";
import { TaxCalculator } from "./taxCalculator";

export type AdoptionTaxCreditProps = {
  moduleInfo: Schema.AdoptionTaxCredit;
};

export function AdoptionTaxCredit(props: AdoptionTaxCreditProps) {
  return (
    <>
      <div className="flex justify-center bg-backgroundgray p-8 ">
        <div className="">
          <div>
            <div className="flex">
              <div className="">
                <h2 className="text-deco-head-6">
                  <em>{props.moduleInfo.taxCredit?.heading}</em>
                </h2>
                <div className="text-body-3 text-left [&>p>a>span]:text-teal">
                  <RichText content={props.moduleInfo.taxCredit?.description} />
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center">
            <div className="flex justify-center">
              <div className="">
                <TaxCalculator moduleInfo={props.moduleInfo} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdoptionTaxCredit;
